import { Stack, Container } from "@mui/material";
import { NewsList } from "../components/NewsList";
import { TextKv } from "../components/TextKv";

export const News = () => {
  return (
    <Stack minHeight="70vh">
      <TextKv text="NEWS" />
      <Container
        sx={{
          paddingLeft: "0 !important",
          paddingRight: "0 !important",
        }}
      >
        <NewsList usePage />
      </Container>
    </Stack>
  );
};
